import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
import { IconSize } from '@foundation/Icon/IconSize';

import IconEdgeTop12 from './IconEdgeTop12';
import IconEdgeTop16 from './IconEdgeTop16';
import IconEdgeTop20 from './IconEdgeTop20';
import IconEdgeTop24 from './IconEdgeTop24';
import IconEdgeTop32 from './IconEdgeTop32';

/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
const IconEdgeTop = (props: GeneratedIconProps): ReactElement<GeneratedIconProps> => {
    const size = props.size || IconSize.Size16;
    return (
        <span>
            {size === IconSize.Size12 && !props.filled && <IconEdgeTop12 {...props} />}
            {size === IconSize.Size16 && !props.filled && <IconEdgeTop16 {...props} />}
            {size === IconSize.Size20 && !props.filled && <IconEdgeTop20 {...props} />}
            {size === IconSize.Size24 && !props.filled && <IconEdgeTop24 {...props} />}
            {size === IconSize.Size32 && !props.filled && <IconEdgeTop32 {...props} />}
        </span>
    );
};
IconEdgeTop.displayName = 'FondueIconEdgeTop';

export default memo(IconEdgeTop);
